export default __webpack_public_path__ + "static/media/Monique Franco_.55514d78.png";